/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const ArrowUpTrend: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 18 10" size={size} color={color} {...props}>
      <path
        d="M12.119 0l1.865 1.865-3.975 3.973L6.75 2.581.714 8.623l1.148 1.148L6.75 4.886l3.259 3.257L15.14 3.02l1.865 1.865V0H12.12z"
        fill="evenodd"
      />
    </Icon>
  );
};

export default ArrowUpTrend;

ArrowUpTrend.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
